import React from "react";
import styled from "@emotion/styled";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
//import colors from "./UiComponent";
import SideBarSingleBar from "./SideBarSingleBar";
import { Button } from "@mui/material";
import StaffContext from "../context/StaffContext";
import { useContext } from "react";
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
const GroupHeader = styled("span")(({theme})=>({
  width: "100%",
  fontSize: "14px",
  textAlign: "left",
  lineHeight: "18.5px",
  color: theme.palette.primary.main,
  padding: "5px",
  fontWeight: 500,
  display:'flex',
  justifyContent:'space-between',
  alignItems:'center',
  cursor:'pointer'
  })
);

const NavGroup = styled.div`
  width: 100%;
  padding: 18px 0px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;
const SideBarWrapper = styled('span')((props)=>({
  display:'flex',
  flexDirection:'column',
  overflowY:'auto',
  scrollbarColor:props.theme.palette.background.scroll,
   scrollbarWidth: 'thin',
  '&::-webkit-scrollbar': {
    width: '0.3em',
    borderRadius:'20px'
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: `inset 0 0 6px ${props.theme.palette.background.shadow}`,
    webkitBoxShadow: `inset 0 0 6px ${props.theme.palette.background.shadow}`
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: props.theme.palette.background.scroll,

  }

}))
function SideBarGroup({ content }) {
 // console.log(content.header, content.children);
 const { state}= useContext(StaffContext);
  return (
    <SideBarWrapper>
    {content.map((cont,index)=>{
      return(
      <NavGroup key={index}>
        {state.sidebar && <GroupHeader >{cont.header} <ArrowForwardIosOutlinedIcon sx={{width:'15px'}}/></GroupHeader>}
        {cont.children.map((val, index) => {
          return <SideBarSingleBar key={index} content={val} />;
        })}
      </NavGroup>)})
      }
      </SideBarWrapper>
  );
}

export default SideBarGroup;
